<div class="page-wraper bg-gray-50">
  <div class="page-title-block workbook-title-block align-items-start">
    <div class="left-content title-block-left flex-1 button-group flex-row header-actions">
      <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip" title="Collapse All" (click)="getExpandCollapse('true')" *ngIf="!isExpanded">
        <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center text-primary-darker"></i>
      </button>
      <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip" title="Expand All" (click)="getExpandCollapse('false')" *ngIf="isExpanded">
        <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center text-primary-darker"></i>
      </button>
      <button mat-button mat-stroked-button title="Refresh" color="dark" class="btn-medium-icon button-tooltip"
        (click)="refreshLeadSheetGrouping()"
        [disabled]="(firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || shortCutMenuDetails.isenglock != 0">
        <i class="fa-regular fa-arrows-rotate"></i>
      </button>
    </div>

    <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center">
      <!-- 1st Column -->

          <h3 class="title">{{headerNotesColumn1}}</h3>


          <!--2nd Column-->
          <div class="flexbox-row gap-8 justify-content-center text-center">
            <ng-container *ngIf="isSecondColumnClicked">

          <mat-form-field class="fixed-label form-field-medium icon-form-after action-2 mr-2" style="width: 300px">
            <input matInput placeholder="" [(ngModel)]="headerNotesColumn2" type="text" class="edit-field" (keyup)="editablelabel($event.target.value)" />
            <div matSuffix class="actions border-start">
                <button mat-button color="success" title="Save" (click)="saveHeaderNote()"
                        [disabled]="!acl?.hasEngViewEdit">
                <i class="fa-regular fa-check"></i>
              </button>
              <button mat-button color="error" title="Cancel" (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn">
                <i class="fa-regular fa-xmark clear-icon"></i>
              </button>
            </div>
          </mat-form-field>
          <h6 class="title">{{engagementYearEnd | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>

            </ng-container>
            <ng-container *ngIf="!isSecondColumnClicked">
              <span style="position: relative;display: inline-block;" class="hover-action" [ngClass]="{'ps-3': shortCutMenuDetails.isenglock != 1}">
                <h6 class="title hover-action d-flex flex-row align-items-center gap-8" [ngClass]="{'ps-2': shortCutMenuDetails.isenglock != 1}" style="min-height:36px;">
                  {{headerNotesColumn2}} {{engagementYearEnd | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}
                    <ng-container *ngIf="acl?.hasEngViewEdit">
                    <button mat-button class="button-text hover-action-item" *ngIf="shortCutMenuDetails.isenglock != 1"
                      (click)="isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2">
                      <i class="fa-regular fa-pen fs-15"></i>
                    </button>
                  </ng-container>
                </h6>
              </span>
            </ng-container>
          </div>
        </div>
        <div class="title-block-right d-none d-lg-flex"></div>
      </div>

    <mat-accordion>
        <mat-expansion-panel class="plan-expansion body-expansion" expanded="true">
          <mat-expansion-panel-header class="d-block d-lg-none filter-actions-button">
            <mat-panel-title>
                    <div class="plan-expansion-header">
                        <button mat-button mat-stroked-button color="dark" class="button-default">
                            <span class="flexbox-row gap-8 flex-nowrap">
                                <span class="title">Actions</span>
                                <span class="toggle-icon dot-16 bg-transparent"></span>
                            </span>
                        </button>
                    </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="plan-expansion-body">
            <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
              <div class="sorting-block-left d-flex flex-row align-items-end gap-8 flex-1">

                <mat-form-field class="form-item fixed-label flex-1" floatLabel="always" style="max-width:300px;width:auto;" title="{{clientName}}">
                  <mat-label>Entity Name</mat-label>
                  <mat-select [(value)]="clientName" [disabled]="true" title="{{clientName}}">
                    <mat-option value="{{clientName}}">
                      {{clientName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="form-item ng-form-field">
                  <label>Year End Date</label>
                  <ng-select placeholder="" [items]="yearEndDetails" [clearable]="false" [clearOnBackspace]="false"
                    bindValue="acctyear" bindLabel="acctdate" [(ngModel)]="selectedYearEnd" [title]="engagementYearEnd | appCountableTimeZone: 'MMM d, y':'UTC'"
                    (change)="refreshLeadSheetGrouping()" class="yearend-dropdown">
          <ng-template ng-option-tmp ng-label-tmp let-item="item">
            {{ item.acctdate | appCountableTimeZone: 'MMM d, y':'UTC'}}
         </ng-template>
                  </ng-select>
                </div>


              </div>
              <div class="sorting-block-right d-flex flex-row gap-8">
                  <form class="search-field-outer">
                      <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always">
                      <mat-label>Search</mat-label>
                      <input matInput #searchField maxlength="20" size="25" placeholder="Search" [(ngModel)]="searchText"
                          [ngModelOptions]="{standalone: true}" (keyup)="handleSearch($event.target.value)" autocomplete="off">
                      <span matPrefix>
                        <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                      </span>
                      </mat-form-field>
                  </form>
                  <!-- for the future purpose -->
                  <button mat-button mat-flat-button color="primary" class="button-default" [matMenuTriggerFor]="addNotesMenu">
                    <span class="flexbox-row gap-8">
                      <i class="fa-regular fa-file-export"></i>
                        <span class="button-label">Export</span>
                        <i class="fa-regular fa-angle-down"></i>
                    </span>
                  </button>
                  <mat-menu #addNotesMenu="matMenu" class="add-notes-menu" xPosition="before">
                    <button title="PDF" type="button" (click)="exportTrailBalanceGrouping();$event.stopPropagation()"
                      mat-menu-item>PDF</button>
                    <button title="Excel" type="button" (click)="exportToExcel();$event.stopPropagation()" mat-menu-item>
                      Excel
                    </button>
                  </mat-menu>
              </div>

            </div>
          </div>
        </mat-expansion-panel>
    </mat-accordion>

  <div class="content-block-main overflow-hidden" >
    <div class="leadsheet-grouping-bodyy card h-100 w-100 auto-scroll-container overflow-auto" id="TBGrid" >
      <div class="flex-table fixed-header hover-action leadsheet-grouping-table " appSpin [spinnerConfig]='spinnerConfig()'>
        <div class="flex-table-header pe-3">
          <p class="ft-cell col-status"></p>
          <p class="ft-cell col-drag-drop"></p>
          <p class="ft-cell col-checkbox"></p>
          <p class="ft-cell col-leadsheet">LS</p>
          <p class="ft-cell col-mapno">Map No.</p>
          <p class="ft-cell col-accno">Acc No.</p>
          <p class="ft-cell col-desc">Description</p>
          <p class="ft-cell col-original text-end">Original</p>
          <p class="ft-cell col-adjusting text-end">Adj</p>
          <p class="ft-cell col-final text-end">Final</p>
          <p class="ft-cell col-py1 text-end">PY1</p>
          <p class="ft-cell col-change text-end">
            Change ({{changeType === 'percentage'?'%':'$'}})
            <button mat-button class="button-text ps-1" [matMenuTriggerFor]="menuch">
                <i class="fa-solid fa-angle-down fs-15"></i>
            </button>
            <mat-menu #menuch="matMenu" xPosition="before">
              <button mat-menu-item (click)="toggleChange('percentage')">
                <span>Change(%)</span>
              </button>
              <button mat-menu-item (click)="toggleChange('doller')">
                <span>Change($)</span>
              </button>
            </mat-menu>
          </p>
          <p class="ft-cell col-notes">Notes</p>
          <p class="ft-cell col-reference">References</p>
        </div>
        <div class="flex-table-body template-block-main full-width-tbl-body" cdkScrollable>
          <mat-accordion #accordion="matAccordion" multi="true" class="w-100">
            <mat-expansion-panel [expanded]="isSearchExist ? leadSheetData.isexpand : isExpanded" #openExpansionPanel
              (mouseenter)="mouseEnterHandler($event, openExpansionPanel)"
              *ngFor="let leadSheetData of getLeadsheetGroupingDetails;let i=index; trackBy: trackByParentRecord">
              <mat-expansion-panel-header *ngIf="leadSheetData.TBrecords" class="collapsed-header">
                <mat-panel-title >
                  <div class="ft-row border-bottom" >
                    <!--Main Header-->
                    <ng-container >
                      <div class="ft-cell col-toogle">
                        <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                        </span>
                      </div>
                      <p class="ft-cell col-header-title flex-1" style="max-width:600px;"
                        title="{{leadSheetData.leadsheetcode}}-{{leadSheetData.leadsheetname}}">
                        <span class="fw-semibold">{{leadSheetData.leadsheetcode}} - {{leadSheetData.leadsheetname}}</span>
                      </p>
                      <p class="ft-cell col-original text-end" title="{{leadSheetData.originaltotal}}">
                        <span class="fw-semibold totalValue">{{leadSheetData.originaltotal}}</span>
                      </p>
                      <p class="ft-cell col-adjusting text-end" title="{{leadSheetData.adjustmentamountotal}}">
                        <span class="fw-semibold totalValue">{{leadSheetData.adjustmentamountotal}}</span>
                      </p>
                      <p class="ft-cell col-final text-end" title="{{leadSheetData.finaltotal}}">
                        <span class="fw-semibold totalValue">{{leadSheetData.finaltotal}}</span>
                      </p>
                      <p class="ft-cell col-py1 col-py1exp text-end" title="{{leadSheetData.py1}}">
                        <span class="fw-semibold totalValue">{{leadSheetData.py1}}</span>
                      </p>
                      <p class="ft-cell col-change col-changeexp text-end" title="{{changeType === 'percentage'?leadSheetData.changepercentage:leadSheetData.dlchanges}}">
                        <span class="fw-semibold totalValue">{{changeType === 'percentage'?leadSheetData.changepercentage:leadSheetData.dlchanges}}</span>
                      </p>
                      <div class="ft-cell col-notes"></div>
                      <div class="ft-cell col-reference"></div>
                    </ng-container>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="panel-body balance-sheet-list-container list-style-none" cdkDropList
                id="{{leadSheetData.leadsheetidcode}}" [cdkDropListConnectedTo]="connectedTo"
                [cdkDropListData]="leadSheetData.TBrecords" (cdkDropListDropped)="drop($event)"
                [ngStyle]="{'cursor': shortCutMenuDetails.isenglock != 0 ? '' : grab}">
                <ng-container>
                  <div *ngFor="let leadSheet of leadSheetData.TBrecords;let tbIndex = index; trackBy: trackByChildRecord"
                    cdkDrag [cdkDragData]="leadSheet" cdkDragBoundary=".auto-scroll-container-out"
                       [cdkDragDisabled]="this.selectedTBLrow.length > 1 || shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit"
                    (mouseover)="shortCutMenuDetails.isenglock != 0 ?  null : leadSheet.selected = true"
                    (mouseout)=" shortCutMenuDetails.isenglock != 0 ?  null : leadSheet.selected = false" class="ft-row border-bottom"
                    [ngClass]="{'searchActive': leadSheet?.ishighlight ==='true'}" (cdkDragStarted)="onDragStarted($event)"
                    (cdkDragEnded)="onDragEnded($event)">
                    <!-- status column -->
                    <div class="ft-cell col-status">
                      <span class="status-badge" [ngClass]="{'bg-error':leadSheet.LSchange == 1}">
                        <span class="status-badge-label">
                          <ng-container *ngIf="leadSheet.LSchange == 1">CHG</ng-container>
                        </span>
                      </span>
                    </div>
                    <!-- Drag column -->
                    <div class="ft-cell col-drag-drop">
                        <ng-container *ngIf="acl?.hasEngViewEdit">
                        <ng-container *ngIf="shortCutMenuDetails.isenglock === 0">
                          <button mat-button class="button-text hover-action-item cursor-grab" [hidden]="!(leadSheet.selected && selectedTBLrow.length < 2)">
                            <i class="fa-solid fa-grip-dots-vertical"></i>
                          </button>
                        </ng-container>
                      </ng-container>
                    </div>

                    <!-- checkbox column -->
                    <div class="ft-cell col-checkbox">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showLSCheckBoxButtons">
                        <mat-checkbox class="label-none" disabled></mat-checkbox>
                      </ng-container>
                      <ng-template #showLSCheckBoxButtons>
                        <mat-checkbox class="label-none" (click)="$event.stopPropagation()"
                          [(ngModel)]="leadSheet.checked" (ngModelChange)="checkLSChange(leadSheet)"
                          [checked]="leadSheet.checked" (click)="changePosition($event, leadSheet)">
                        </mat-checkbox>
                        <span class="lsposition" style="position: absolute;" [matMenuTriggerFor]="lsmapdropdown"
                          #multipleMoveMenu="matMenuTrigger"></span>
                        <mat-menu #lsmapdropdown="matMenu" class="main-container-ls max-w-initial" yPosition="below" [hasBackdrop]="false">
                          <div class="flexbox-row h-100 overflow-hidden gap-0" (click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()"
                            (keydown.shift.tab)="$event.stopPropagation()" tabindex="-1" style="display: none;"
                            id="LSMAPDialog">
                            <div class="leadsheet-map-container-section-left h-100 overflow-hidden" style="width: 150px;">
                              <button mat-menu-item class="w-100" [disabled]="leadsheetdisable" (click)="activeMultiLS(leadSheet, $event)" [ngStyle]="{'background': activeLsMove ? 'rgba(0, 0, 0, 0.04)' : ''}">
                                <div class="flexbox-row gap-8 justify-content-between">
                                    <span class="button-label">Leadsheet</span>
                                    <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                </div>
                              </button>
                              <button mat-menu-item class="w-100" (click)="activeMultiMapNo(leadSheet, $event)" [ngStyle]="{'background': activeMapMove ? 'rgba(0, 0, 0, 0.04)' : ''}">
                                <div class="flexbox-row gap-8 justify-content-between">
                                    <span class="button-label">Map No.</span>
                                    <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                </div>
                              </button>
                            </div>

                            <!-- Mutiple leadsheet moving through LS AND MAP NO. start -->
                            <ng-container *ngIf="activeLsMove || activeMapMove">
                              <div class="leadsheet-container-right ls-menu flexbox-column gap-0 h-100 overflow-hidden border-start">
                                <div class="button-group justify-content-end px-2 pt-2">
                                  <button mat-button class="button-text" (click)="clearSelection()">
                                    <i class="fa-regular fa-xmark"></i>
                                  </button>
                                </div>
                                <div class="leadsheet-map-container-section-right map-section-right overflow-auto h-100">
                                  <!--Latest LS to move-->
                                  <ng-container *ngIf="leadSheet.isLeadSheet && activeLsMove">
                                    <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="leadSheet"
                                      [moveType]="'MULTI'" [subscribeFrom]="'LSG'"></ls-dropdown>
                                  </ng-container>
                                  <!--Latest MAP NO move-->
                                  <ng-container *ngIf="leadSheet.isMap && activeMapMove">
                                    <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="leadSheet"
                                      [moveType]="'MULTI'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                                      [subscribeFrom]="'LSG'">
                                    </map-dropdown>
                                    <!--</ng-container> -->
                                  </ng-container>
                                </div>
                                <div class="button-group justify-content-end p-2" *ngIf="hideMoveButton">
                                  <button mat-button mat-flat-button color="primary" class="button-default"
                                    [disabled]="isDisableMoveButton"
                                    (click)="activeLsMove ? saveLeadSheetdetails():savemappingdetails()">
                                    Move
                                  </button>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </mat-menu>
                      </ng-template>
                    </div>

                    <!-- Leadsheet cloumn -->
                    <div class="ft-cell col-leadsheet">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookLeadsheetButtons">
                        <button mat-button class="button-text w-100"
                          title="{{leadSheet.leadsheetname ? leadSheet.leadsheetname : '-'}}" disabled>
                          {{leadSheet.leadsheetcode ? leadSheet.leadsheetcode : '-'}}
                        </button>
                      </ng-container>
                      <ng-template #showWorkBookLeadsheetButtons>
                        <button mat-button class="button-text text-left"
                          [disabled]="leadSheet.leadsheetcode === null || leadSheet.leadsheetcode === 0 || selectedTBLrow.length > 0"
                          title="{{leadSheet.leadsheetname ? leadSheet.leadsheetname : '-'}}"
                          [matMenuTriggerFor]="gidLeadeShaeetItems" (click)="activeLSDropdown(leadSheet)"
                          (mouseover)="leadSheet.isLSHover = true" (mouseout)="leadSheet.isLSHover = false">
                          <span class="text-link">{{leadSheet.leadsheetcode ? leadSheet.leadsheetcode : '-'}}</span>
                          <i *ngIf="leadSheet.isLSHover" class="fa-solid fa-angle-down fs-15"></i>
                        </button>
                        <mat-menu #gidLeadeShaeetItems="matMenu" class="leadsheet-container ls-menu" xPosition="after"
                          yPosition="below">
                          <ng-container *ngIf="leadSheet.isLeadSheet && isSingleRecordSave">
                            <ls-dropdown [TbLeadSheetId]="leadSheet.leadsheetid" [parentObject]="leadSheet"
                              [moveType]="'SINGLE'" [yearType]="'CURRENT'" [subscribeFrom]="'LSG'"></ls-dropdown>
                          </ng-container>
                        </mat-menu>
                      </ng-template>
                    </div>

                    <!-- Mapno Column -->
                    <div class="ft-cell col-mapno" (click)="$event.stopPropagation()">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkbookMapButtons">
                        <div class="flex-box-col">
                          <button mat-button class="button-text" title="{{leadSheet.tmapname ? leadSheet.tmapname : '-'}}" disabled>
                            {{leadSheet.tmapno ? leadSheet.tmapno : '-'}}
                          </button>
                        </div>
                      </ng-container>
                      <ng-template #showWorkbookMapButtons>
                        <div class="flex-box-col">
                          <button mat-button class="button-text"
                            title="{{leadSheet.tmapname ? leadSheet.tmapname : '-'}}" [matMenuTriggerFor]="gridMapNumDropDown"
                            [disabled]="selectedTBLrow.length > 0" (click)="mappingNumber(leadSheet)"
                            (mouseover)="leadSheet.isMapHover = true" (mouseout)="leadSheet.isMapHover = false">
                            {{leadSheet.tmapno ? leadSheet.tmapno : '-'}}
                            <i *ngIf="leadSheet.isMapHover" class="fa-solid fa-angle-down fs-15"></i>
                          </button>
                        </div>
                        <mat-menu #gridMapNumDropDown="matMenu" class="map-menu map-dropdown-container" xPosition="after"
                          yPosition="below">
                          <ng-container *ngIf="leadSheet.isMap && isSingleRecordSave">
                            <map-dropdown [tbMapsheetId]="leadSheet.mastermapsheetid" [parentObject]="leadSheet"
                              [moveType]="'SINGLE'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                              [subscribeFrom]="'LSG'"></map-dropdown>
                          </ng-container>
                        </mat-menu>
                      </ng-template>
                    </div>

                    <!-- Account no column -->
                    <p title="{{leadSheet.taccountcode}}" class="ft-cell col-accno">
                      <span class="text-ellipse">{{leadSheet.taccountcode}}</span>
                    </p>

                    <!--Description column-->
                    <p title="{{leadSheet.taccountname}}" class="ft-cell col-desc">
                      <span class="text-ellipse" [ngClass]="{'textColor': leadSheet.ishighlight === true}">
                        {{leadSheet.taccountname}}
                      </span>
                    </p>

                    <!-- Original column -->
                    <p title="{{leadSheet.toriginalbalance}}" class="ft-cell col-original text-end">
                      <span class="text-ellipse">{{leadSheet.toriginalbalance}}</span>
                    </p>

                    <!-- Adjusting column -->
                    <div title="{{leadSheet.tadjustmentamount}}" class="ft-cell col-adjusting text-end">
                      <div class="flex-box-col">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showLSAdjButtons">
                          <button mat-button class="button-text text-ellipse w-100"
                            title="{{leadSheet.tadjustmentamount}}" disabled>
                            {{leadSheet.tadjustmentamount}}
                          </button>
                        </ng-container>
                        <ng-template #showLSAdjButtons>
                          <ng-container *ngIf="leadSheet.tadjustmentamount !== '0.00'">
                            <button mat-button class="button-text map-hover-color text-ellipse w-100"
                              title="{{leadSheet.tadjustmentamount}}" [matMenuTriggerFor]="adjustmentmnenu"
                              (click)="getAdjustmentGroupDetails(leadSheet)">
                              {{leadSheet.tadjustmentamount}}
                            </button>
                          </ng-container>
                          <ng-container *ngIf="leadSheet.tadjustmentamount === '0.00'">
                            <button mat-button class="button-text map-hover-color text-ellipse w-100"
                              title="{{leadSheet.tadjustmentamount}}">
                              {{leadSheet.tadjustmentamount}}
                            </button>
                          </ng-container>
                          <mat-menu #adjustmentmnenu="matMenu" #beforeMenu="matMenu" xPosition="before">
                            <ng-container>
                              <table mat-table [dataSource]="adjustmentGroupDetails"
                                class="mat-elevation-z8 adjustmenttable-grid">
                                <ng-container matColumnDef="entryno">
                                  <th mat-header-cell *matHeaderCellDef class="col-entrynum">Entry No. </th>
                                  <td mat-cell *matCellDef="let element" class="col-entryno">
                                    <div class="flex-box-vc-hl">
                                      <p class="ellipse no-marg">{{element.groupname}}</p>
                                    </div>
                                  </td>
                                  <td mat-footer-cell *matFooterCellDef class="col-total"></td>
                                </ng-container>
                                <ng-container matColumnDef="ref">
                                  <th mat-header-cell *matHeaderCellDef class="col-entrynum">
                                    <div class="flex-box-vc-hl">REF</div>
                                  </th>
                                  <td mat-cell *matCellDef="let element" class="col-entryno adj-colr">
                                    <div class="flex-box-vc-hl">
                                      <p [matMenuTriggerFor]="refmenu" class="tick-menulist ellipse no-marg"
                                        style="cursor: pointer;" (click)="$event.stopPropagation()">
                                        <ng-container *ngFor="let ref of element.Referenc; let i = index">
                                          <span *ngIf="i < 2" style="padding-right:1px;">
                                            <!-- {{ref.REF}}{{ i === 0 ? ',' : (i === 1 ? '' : '')}} -->
                                            <span *ngIf="i === 0">
                                              {{ref.REF}}
                                            </span>
                                            <span *ngIf="i === 1">
                                              {{',' + ref.REF}}
                                            </span>
                                          </span>
                                        </ng-container>
                                        <ng-container *ngIf="element.Referenc && element.Referenc.length > 2">{{'...'}}
                                        </ng-container>
                                      </p>
                                      <ng-container *ngIf="!element.Referenc">
                                        <p class="tick-menulist ellipse no-marg">-</p>
                                      </ng-container>
                                    </div>
                                    <mat-menu #refmenu="matMenu" xPosition="before" yPosition="below"
                                      class="reference-menu">
                                      <div class="reference-menu-details">
                                        <ul class="cust-items">
                                          <li *ngFor="let refDoc of element.Referenc">
                                            <div class="reference-menu-details-list">
                                              <div appFilePreview [fileData]="refDoc" [inline]="false"
                                                class="float-left list-left">
                                                <p class="ellipse no-marg hand-cursor" title="{{refDoc.filename}}">
                                                  {{refDoc.filename}} </p>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </mat-menu>
                                  </td>
                                  <td mat-footer-cell *matFooterCellDef class="col-total">
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="total">
                                  <th mat-header-cell *matHeaderCellDef class="col-totalnum">
                                    <div class="flex-box-vc-hr">Total</div>
                                  </th>
                                  <td mat-cell *matCellDef="let element" class="col-total">
                                    <div class="flex-box-vc-hr">
                                      <p class="ellipse no-marg">{{element.amount}}</p>
                                    </div>
                                  </td>
                                  <td mat-footer-cell *matFooterCellDef class="col-total">
                                    <div class="flex-box-vc-hr">
                                      <p class="ellipse no-marg">{{leadSheet.tadjustmentamount}}</p>
                                    </div>
                                  </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                                <tr mat-footer-row *matFooterRowDef="displayedColumns2"></tr>
                              </table>
                            </ng-container>
                          </mat-menu>
                        </ng-template>

                      </div>
                    </div>

                    <!-- Final panel column -->
                    <p title="{{leadSheet.tfinalamount}}" class="ft-cell col-final text-end">
                      <span class="text-ellipse">{{leadSheet.tfinalamount}}</span>
                    </p>

                    <!-- PY1 Column -->
                    <p title="{{leadSheet.tpy1}}" class="ft-cell col-py1 text-end">
                      <span class="text-ellipse">{{leadSheet.tpy1}}</span>
                    </p>

                    <!-- Change Column -->
                    <p title="{{changeType === 'percentage'?leadSheet.tchangepercentage:leadSheet.tdlchanges}}" class="ft-cell col-change text-end">
                      <span class="text-ellipse">{{changeType === 'percentage'?leadSheet.tchangepercentage:leadSheet.tdlchanges}}</span>
                    </p>

                    <!-- Notes Column -->
                    <div class="ft-cell col-notes">
                      <ng-container *ngIf="leadSheet.Notes === 0">
                        <button mat-button class="button-smaller-icon cust-badge" title="Note" color="dark"
                          [matMenuTriggerFor]="notes"
                          [ngStyle]="{'pointer-events': sharedService.isProcedureEditor ? 'none': 'auto'}"
                                [disabled]="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit"
                          (click)="$event.stopPropagation(); getNotesDetails(leadSheet)">
                          <span class="mat-badge nav-icon mat-badge-warn mat-badge-overlap mat-badge-above mat-badge-after mat-badge-small"
                            matBadgePosition="above after" matBadgeSize="small" matBadgeColor="warn">
                                <i class="fa-light fa-file-lines"></i>
                            </span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="leadSheet.Notes > 0">
                        <button mat-button class="button-smaller-icon cust-badge" title="Note" color="dark"
                          [matMenuTriggerFor]="notes" (click)="getNotesDetails(leadSheet)">
                          <!-- <i class="fa-regular fa-note notes-icon  cust-badge" matBadgePosition="above after" matBadgeSize="medium" matBadge="{{leadSheet.Notes}}" matBadgeColor="warn"></i> -->
                          <span class="mat-badge nav-icon mat-badge-warn mat-badge-overlap mat-badge-above mat-badge-after mat-badge-small"
                            matBadgePosition="above after" matBadgeSize="small" matBadge="{{leadSheet.Notes}}"
                            matBadgeColor="warn">
                            <i class="fa-light fa-file-lines"></i>
                        </span>
                        </button>
                      </ng-container>
                      <mat-menu #notes="matMenu" class="notes-panel" #beforeMenu="matMenu" xPosition="before"
                        (click)="$event.stopPropagation()" [hasBackdrop]="false">
                        <div class="notes-container">
                          <!--Add Note Container-->
                          <ng-container *ngIf="leadSheet.addNotes">
                            <form class="horizontal-items p-2" autoComplete="off">
                              <mat-form-field class="fixed-label w-100" floatLabel="always"
                                (click)="$event.stopPropagation()">
                                <mat-label>Add a Note</mat-label>
                                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" maxlength="256"
                                  (keyup)="checkActionCharterlength($event.target.value)" id="note"
                                  [(ngModel)]="leadSheet.selectedNotes" [ngModelOptions]="{standalone: true}"
                                  placeholder="Type here" required></textarea>
                              </mat-form-field>
                              <div class="button-group justify-content-end">
                                <button mat-button mat-stroked-button color="dark" class="button-medium"
                                  (click)="cancelNote(leadSheet)">
                                  Cancel
                                </button>
                                <button mat-button mat-flat-button color="primary" class="button-medium"
                                  (click)="saveNotes(leadSheet)"
                                        [disabled]="isActionCharterLimitExceed || !acl?.hasEngViewEdit || !leadSheet.selectedNotes?.trim()">
                                  Save
                                </button>
                              </div>
                            </form>

                          </ng-container>

                          <!--View all the Notes Container-->
                          <ng-container *ngIf="leadSheet.viewNotes">
                            <div class="notes-view" (click)="$event.stopPropagation()">
                              <div class="flexbox-row justify-content-end p-2">
                                <button mat-button class="button-text" (click)="cancelNote(leadSheet);">
                                  <i class="fa-regular fa-xmark clear-icon"></i>
                                </button>
                              </div>
                              <div class="flexbox-row justify-content-between px-2 pb-2 border-bottom">
                                <h6 class="title">Notes ({{leadSheet.Notes}})</h6>
                                  <button mat-button class="button-text"
                                          (click)="$event.stopPropagation(); addNewNotes(leadSheet)"
                                          [disabled]="shortCutMenuDetails.isenglock  !=0 || !acl?.hasEngViewEdit">
                                    <span class="flexbox-row gap-8">
                                      <i class="fa-solid fa-plus"></i>
                                      <span class="button-label">New Note</span>
                                    </span>
                                </button>
                              </div>
                              <ul class="templates-list-items h-100 overflow-auto">
                                <li class="list-item-content h-auto py-2" *ngFor="let notes of notesList">
                                  <div class="partner-view user-list-item" (click)="$event.stopPropagation(); viewNotes(leadSheet, notes)">
                                    <!-- <ngx-avatars size="24" [name]="all.fullname"></ngx-avatars> -->
                                    <span class="dot dot-primary dot-24">
                                      {{getShortName(notes.fullname)}}
                                    </span>
                                    <div class="item-content">
                                      <p class="name text-link text-ellipse" title="{{notes.fullname}}">
                                        {{notes.fullname}}
                                      </p>
                                      <p class="date" title="{{notes.raisedddate | appCountableTimeZone}}">
                                        {{notes.raisedddate | appCountableTimeZone}}
                                      </p>
                                    </div>
                                  </div>
                                    <button mat-button class="kebab-menu-button kebab-button" [matMenuTriggerFor]="menu"
                                            aria-label="" #t="matMenuTrigger"
                                            [disabled]="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit"
                                            (click)="$event.stopPropagation()">
                                    <i class="fas fa-ellipsis-vertical"></i>
                                  </button>
                                  <mat-menu #menu="matMenu" #beforeMenu="matMenu"
                                    xPosition="before" (click)="$event.stopPropagation()">
                                      <button mat-menu-item [disabled]="!acl?.hasEngViewEdit"
                                      (click)="$event.stopPropagation(); editNotes(leadSheet, notes)">
                                      <span class="flexbox-row gap-8">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                        <span class="button-label">Edit</span>
                                      </span>
                                    </button>
                                      <button mat-menu-item [disabled]="!acl?.hasEngViewEdit"
                                      (click)="deleteNoteDailog(leadSheet, notes);">
                                      <span class="flexbox-row gap-8">
                                          <i class="fa-regular fa-trash-can"></i>
                                          <span class="button-label">Delete</span>
                                      </span>
                                    </button>
                                  </mat-menu>
                                </li>
                              </ul>
                            </div>
                          </ng-container>

                          <!-- Notes Details view and Edit History-->
                          <ng-container *ngIf="leadSheet.viewNotesDetails">
                            <div class="notes-viewfull">
                              <!---View Full Notes-->
                              <ng-container *ngIf="leadSheet.viewNotesDetails">
                                <div class="button-group p-2 border-bottom">
                                  <button mat-button class="button-text" (click)="$event.stopPropagation(); backToView(leadSheet);">
                                    <i class="fa-regular fa-arrow-left"></i>
                                  </button>
                                  <h6 class="title">Notes</h6>
                                </div>
                                <ul class="templates-list-items h-100 overflow-auto">
                                  <li class="h-auto p-0">
                                    <div class="list-item-content p-2 cursor-default">
                                      <div class="partner-view user-list-item" (click)="$event.stopPropagation(); viewNotes(leadSheet, notes)">
                                        <!-- <ngx-avatars size="24" [name]="all.fullname"></ngx-avatars> -->
                                        <span class="dot dot-primary dot-24">
                                          {{getShortName(notesDetails.fullname)}}
                                        </span>
                                        <div class="item-content">
                                          <p class="name text-link text-ellipse" title="{{notesDetails.fullname}}">
                                            {{notesDetails.fullname}}
                                          </p>
                                          <p class="date" title="{{notesDetails.raisedddate | appCountableTimeZone}}">
                                            {{notesDetails.raisedddate | appCountableTimeZone}}
                                          </p>
                                        </div>
                                      </div>
                                        <button mat-button class="kebab-menu-button kebab-button"
                                                [matMenuTriggerFor]="menu" aria-label="" #t="matMenuTrigger"
                                                [disabled]="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit"
                                                (click)="$event.stopPropagation()">
                                        <i class="fas fa-ellipsis-vertical"></i>
                                      </button>
                                      <mat-menu #menu="matMenu" #beforeMenu="matMenu" xPosition="before" (click)="$event.stopPropagation()">
                                          <button mat-menu-item [disabled]="!acl?.hasEngViewEdit"
                                          (click)="$event.stopPropagation(); editNotes(leadSheet, notesDetails);">
                                          <span class="flexbox-row gap-8">
                                            <i class="fa-regular fa-pen fs-15"></i>
                                            <span class="button-label">Edit</span>
                                          </span>
                                        </button>
                                          <button mat-menu-item [disabled]="!acl?.hasEngViewEdit"
                                          (click)="deleteNoteDailog(leadSheet, notesDetails)">
                                          <span class="flexbox-row gap-8">
                                              <i class="fa-regular fa-trash-can"></i>
                                              <span class="button-label">Delete</span>
                                          </span>
                                        </button>
                                      </mat-menu>
                                    </div>

                                    <div class="p-2">
                                      <p>{{notesDetails.description}}</p>
                                    </div>
                                  </li>
                                </ul>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                      </mat-menu>
                    </div>

                    <!-- Reference Column"-->
                    <div class="ft-cell col-reference">
                      <button mat-button class="button-text reference-btn" [matMenuTriggerFor]="reference"
                        *ngIf="leadSheet.Referenc">
                        <ng-container *ngFor="let ref of leadSheet.Referenc; let i = index">
                          <span *ngIf="i < 2" style="padding-right:1px;">
                            <span *ngIf="i === 0">
                              {{ref.referencename}}
                            </span>
                            <span *ngIf="i === 1">
                              {{',' + ref.referencename}}
                            </span>
                          </span>
                        </ng-container>
                        <ng-container *ngIf="leadSheet.Referenc.length > 2">{{'...'}}</ng-container>
                      </button>
                      <mat-menu #reference="matMenu">
                        <ng-container *ngFor="let ref of leadSheet.Referenc">
                          <button appFilePreview [fileData]="ref" [inline]="false" mat-menu-item>{{ref.filename}}</button>
                        </ng-container>
                      </mat-menu>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="panel-footer" *ngIf="leadSheetData.isexpand">
                <div class="ft-row">
                  <p class="ft-cell col-status"></p>
                  <p class="ft-cell col-drag-drop"></p>
                  <p class="ft-cell col-checkbox"></p>
                  <p class="ft-cell col-leadsheet"></p>
                  <p class="ft-cell col-mapno"></p>
                  <p class="ft-cell col-accno"></p>
                  <p class="ft-cell col-desc" title="{{leadSheetData.totalname}}">
                    <span class="text-ellipse fw-semibold">{{leadSheetData.totalname}}</span>
                  </p>
                  <p class="ft-cell col-original text-end" title="{{leadSheetData.originaltotal}}">
                    <span class="fw-semibold">{{leadSheetData.originaltotal}}</span>
                  </p>
                  <p class="ft-cell col-adjusting text-end" title="{{leadSheetData.adjustmentamountotal}}">
                    <span class="fw-semibold">{{leadSheetData.adjustmentamountotal}}</span>
                  </p>
                  <p class="ft-cell col-final text-end" title="{{leadSheetData.finaltotal}}">
                    <span class="fw-semibold">{{leadSheetData.finaltotal}}</span>
                  </p>
                  <p class="ft-cell col-py1 text-end" title="{{leadSheetData.py1}}">
                    <span class="fw-semibold">{{leadSheetData.py1}}</span>
                  </p>
                  <p class="ft-cell col-change text-end"></p>
                  <p class="ft-cell col-notes"></p>
                  <p class="ft-cell col-reference"></p>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="flex-table total-row-table w-100">
            <ng-container *ngFor="let leadSheetData of getLeadsheetGroupingDetails; let last = last">
              <div class="ft-row" *ngIf="last">
                <!-- <p class="ft-cell col-status"></p>
                <p class="ft-cell col-drag-drop"></p>
                <p class="ft-cell col-checkbox"></p>
                <p class="ft-cell col-leadsheet"></p>
                <p class="ft-cell col-mapno"></p>
                <p class="ft-cell col-accno"></p> -->
                <p class="ft-cell col-title flex-1" style="max-width:650px;"></p>
                <p class="ft-cell col-original text-end">
                  <!-- when the total is not equal to zero then red color need to be shown class="text-error" -->
                  <span class="text-ellipse fw-semibold" [ngClass]="{'text-error': leadSheetData.alloriginaltotal !== '0.00'}">
                    {{leadSheetData.alloriginaltotal}}
                  </span>
                </p>
                <p class="ft-cell col-adjusting text-end">
                  <span class="text-ellipse fw-semibold" [ngClass]="{'text-error': leadSheetData.alladjustmentamount !== '0.00'}">
                    {{leadSheetData.alladjustmentamount}}
                  </span>
                </p>
                <p class="ft-cell col-final text-end">
                  <span class="text-ellipse fw-semibold" [ngClass]="{'text-error': leadSheetData.allfinaltotal !== '0.00'}">
                    {{leadSheetData.allfinaltotal}}
                  </span>
                </p>
                <p class="ft-cell col-py1 text-end">
                  <span class="text-ellipse fw-semibold" [ngClass]="{'text-error': leadSheetData.allpy1 !== '0.00'}">
                    {{leadSheetData.allpy1}}
                  </span>
                </p>
                <p class="ft-cell col-change text-end">
                  <span class="text-ellipse fw-semibold"></span>
                </p>
                <p class="ft-cell col-notes"></p>
                <p class="ft-cell col-reference"></p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Dailog Box-->

<ng-template #createLeadsheetDialog>
  <div class="create-leadsheet-dialog">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
          <span>Create New Lead Sheet</span>
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close]>
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content>
      <form autoComplete="off" [formGroup]="addLeadSheetForm">
        <div class="row no-marg">
          <mat-form-field class="full-row">
            <mat-label>Group</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="groupName" required>
              <mat-option *ngFor="let group of leadSheetGroup" [value]="group.fingroupname">
                {{group.fingroupname}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row no-marg">
          <mat-form-field class="full-row">
            <mat-label>Sub Group</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="subGroupName" required>
              <mat-option>C - Assets</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row no-marg">
          <mat-form-field class="full-row">
            <mat-label>Lead Sheet Code</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="leadSheetCode" required>
              <mat-option *ngFor="let leadsCode of leadSheetCodeDetails" [value]="leadsCode.leadsheetcode">
                {{leadsCode.leadsheetcode}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row no-marg">
          <mat-form-field class="full-row">
            <input matInput placeholder="Lead Sheet Name" formControlName="leadSheetName" required>
          </mat-form-field>
        </div>
      </form>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no" (click)="$event.stopPropagation()">
        <button mat-flat-button class="float-right yesno-btn" color="primary">
          Add
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- save lead sheet message box -->
<ng-template #saveLeadsheetDialog>
  <div class="countable-dialog confirmation-dailog saveLeadsheetDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Move Lead Sheet</h4>
      <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p class="para-text">You are trying to move to Lead Sheet <span class="fw-semibold">{{leadSheetName}}</span>.</p>
      <p class="para-text">Do you want to continue?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark"
        [mat-dialog-close] (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary"
        [mat-dialog-close] (click)="saveLeadSheetdetails()">Yes</button>
    </div>
  </div>
</ng-template>

<!--save Map no message box -->
<ng-template #saveMapNoDialog>
  <div class="countable-dialog confirmation-dailog saveMapNoDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Move Map No.</h4>
      <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p class="para-text">You are trying to move to Map Number  <span class="fw-semibold">{{mapNo}}</span>.</p>
      <p class="para-text">Do you want to continue?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark"
        [mat-dialog-close] (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary"
        [mat-dialog-close] (click)="savemappingdetails()">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #deletenoteDialog>
  <div class="countable-dialog confirmation-dailog deletenoteDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title">Delete</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>You are trying to delete a note</p>
      <p>Do you want to continue?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="button-default" color="error"
        [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>
